import { defineStore, acceptHMRUpdate } from 'pinia'
import { tnApi } from '@/api'

export const useContactStore = defineStore('contact_store', {
  state: () => ({
    contact: {},
    contactEdit: {},
    contacts: [],
    contactTemplate: {
      id: null,
      is_contactor: true,
      salutation_id: 0,
      last_name: '',
      first_name: '',
      company: '',
      title: '',
      email: '',
      street: '',
      zip: '',
      city: '',
      uid: 0,
      country_id: 0,
      phone: '',
      note: '',
      language_id: 0,
      parent: null,
      parent_id: 0
    },
    isLoading: false,
    isSaving: false,
    isLoadingDetails: false
  }),
  actions: {
    async setContact (contact) {
      if (contact === null) {
        this.contact = Object.assign({}, this.contactTemplate)
        this.contactEdit = Object.assign({}, this.contactTemplate)
      } else {
        this.contact = Object.assign({}, contact)
        this.contactEdit = Object.assign({}, contact)
      }
    },
    filter (search) {
      return this.contacts
    },
    async save (values) {
      try {
        const { contactsSave } = tnApi(true)
        this.isSaving = true
        const { contact } = await contactsSave(this.contact?.id || 0, { contact: values })
        const store = useContactStore()
        store.$patch((state) => {
          state.contact = contact
          state.contactEdit = contact
        })
        this.isSaving = false
        return Promise.resolve(contact)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async load () {
      this.isLoading = true
      try {
        const { contactsLoad } = tnApi(true)
        const { contacts } = await contactsLoad()
        this.contacts = contacts
        this.isLoading = false
      } catch (error) {
        return Promise.reject(error)
      }
    },
    add () {
      this.contact = Object.assign({}, this.contactTemplate)
      this.contactEdit = Object.assign({}, this.contactTemplate)
      return this.contactTemplate
    },
    undo () {
      this.contactEdit = Object.assign({}, this.contact)
    },
    async find (id) {
      try {
        console.log('find', id)
        this.isLoadingDetails = true
        const { contactsFind } = tnApi(true)
        const { contact } = await contactsFind(id)
        console.log(contact)
        this.contact = Object.assign({}, contact)
        this.contactEdit = Object.assign({}, contact)
        this.isLoadingDetails = false
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useContactStore, import.meta.hot))
}
